const modifiersKeys = [
    'Alt',
    'AltGraph',
    'Control',
    'Meta',
    'Shift',
];
export default function checkModifierKeyActivated(event) {
    return modifiersKeys.some((key) => event.getModifierState(key));
}
